import moment from "moment/moment.js"
import format from 'root-core/utils/text/stringFormatFilter.js'
import BaseTabSchema from 'root-packages/tabSchemaValidation/baseTabSchema.js'

export default class TourOverviewDayTourSchema extends BaseTabSchema {
  constructor (options) {
    super(options)
  }

  passengerDateOfBirth () {
    return (value, is, object) => {
      if (object.type === 'child' && this.config.features.dobRequired) {
        is(this.passengersSchemaFunctions.date)
      }
      if (!value) {
        return
      }

      const ageAtDeparture = moment(this.departure.startDate.date).diff(this.passengersSchemaFunctions.parseDate(value), 'years')
      if (object.type === 'adult') {
        const adultAgeFrom = this.departure.adultAgeFrom || 18
        if (ageAtDeparture < adultAgeFrom) {
          return format(
            this.config.errorMessages.adultPermittedAgeMin,
            adultAgeFrom
          )
        }
      } else if (object.type === 'child') {
        if (object.age && ageAtDeparture !== object.age) {
          return this.config.errorMessages.ageNotMatchingDOB
        }
        if (ageAtDeparture < this.departure.childAgeFrom || ageAtDeparture > this.departure.childAgeTo) {
          return format(
            this.config.errorMessages.childPermittedAgeRange,
            this.departure.childAgeFrom,
            this.departure.childAgeTo
          )
        }

        const ageAtBooking = moment().diff(this.passengersSchemaFunctions.parseDate(value), 'years')

        if (ageAtBooking < this.departure.childAgeFrom && ageAtDeparture >= this.departure.childAgeFrom) {
          return format(
            this.config.errorMessages.childAge4OnDateOfBooking5OnDateOfDeparture,
            ageAtBooking,
            ageAtDeparture,
            this.config.phone.general
          )
        }
      }
    }
  }

  pickupLocationSelected () {
    return (value) => {
      if (!value) {
        return 'Please select pick up location!'
      }
    }
  }

  buildSchema () {
    return {
      passengers: [
        {
          dateOfBirth: this.passengerDateOfBirth(),
        },
      ],
      pickupLocation: this.pickupLocationSelected(),
    }
  }
}
